import VpnKeyIcon from '@mui/icons-material/VpnKey';
import { useTheme } from '@mui/material/styles';
import { useTranslation } from 'react-i18next';
import { DetailCard } from '../../../../components/ui/DetailCard';
import { RegistrationKeySection } from '../registrationKey/RegistrationKeySection';
import type { GeneratedKey, RegistrationKey } from '../../instanceTypes';

interface InstanceKeysSectionProps {
  keys: RegistrationKey[];
  keysLoading: boolean;
  generating: boolean;
  newKey: GeneratedKey | null;
  revoking: boolean;
  onGenerate: () => void;
  onRevoke: (key: RegistrationKey) => void;
  onDismissKey: () => void;
  readOnly?: boolean;
}

export function InstanceKeysSection({
  keys,
  keysLoading,
  generating,
  newKey,
  revoking,
  onGenerate,
  onRevoke,
  onDismissKey,
  readOnly = false,
}: InstanceKeysSectionProps) {
  const theme = useTheme();
  const { t } = useTranslation('instances');
  const accent = theme.navigation.main.selectedAccent;

  return (
    <DetailCard
      strip={accent}
      iconBg={accent}
      icon={<VpnKeyIcon aria-hidden="true" sx={{ fontSize: theme.iconSize.sm }} />}
      title={t('detail.section.keys')}
    >
      <RegistrationKeySection
        keys={keys}
        loading={keysLoading}
        revoking={revoking}
        generating={generating}
        onRevoke={onRevoke}
        onGenerate={onGenerate}
        newKey={newKey}
        onDismissKey={onDismissKey}
        readOnly={readOnly}
      />
    </DetailCard>
  );
}
